var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreviewSlidesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3C14.0147 3 12 5.01472 12 7.5V64.5C12 66.9853 14.0147 69 16.5 69H55.5C57.9853 69 60 66.9853 60 64.5V21L42 3H16.5Z",
    fill: "#F4B70A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 69C14.0147 69 12 66.9853 12 64.5V63.75C12 66.2353 14.0147 68.25 16.5 68.25H55.5C57.9853 68.25 60 66.2353 60 63.75V64.5C60 66.9853 57.9853 69 55.5 69H16.5Z",
    fill: "#EFA904"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3C14.0147 3 12 5.01472 12 7.5V8.25C12 5.76472 14.0147 3.75 16.5 3.75H42.75L42 3H16.5Z",
    fill: "#F6C028"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9992 36.375V21L57.3742 18.375H44.7151C43.7129 18.375 43.2109 19.5868 43.9197 20.2955L59.9992 36.375Z",
    fill: "url(#paint0_linear_5259_88320)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42 3L60 21H46.5C44.0147 21 42 18.9853 42 16.5V3Z",
    fill: "#FADC87"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 33C24.6716 33 24 33.6716 24 34.5V55.5C24 56.3284 24.6716 57 25.5 57H46.5C47.3284 57 48 56.3284 48 55.5V34.5C48 33.6716 47.3284 33 46.5 33H25.5ZM45 39.75H27V50.25H45V39.75Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5259_88320",
    x1: 51.7935,
    y1: 36.375,
    x2: 51.7935,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B70A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2930A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewSlidesIcon);
export default __webpack_public_path__ + "static/media/PreviewSlidesIcon.48a5990f041aa0c69522407015f71a4f.svg";
export { ForwardRef as ReactComponent };